/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { HeaderState } from "~/features/header/types";
import { RootState } from "~/state/types";

const getState = (state: RootState) => state.header;

const createSelector =
  <TSelected = unknown>(selector: (state: HeaderState) => TSelected): ((rootState: RootState) => TSelected) =>
  (rootState) =>
    selector(getState(rootState));

export const selectMenuWidth = createSelector((state) => state.menuWidth);
